import { reatomAsync, withAbort } from "@reatom/async";
import { StartExportTaskRequestDto } from "definitions/exporter";
import { API } from "src/api";
import { toastHandler, truncateStart } from "src/util";

export const startExportTaskRequest = reatomAsync(
  async (ctx, data: StartExportTaskRequestDto) => {
    API.exporterQueueApi
      .exportControllerStartExportTask(data, {
        signal: ctx.controller.signal,
      })
      .then((response) => {
        const success = response.data;
        if (success) {
          toastHandler.success({
            name: "createExportTask",
            title: data.cronTask ? "Запуск регулярной задачи" : "Запуск задачи",
            content: `${data.cronTask ? "Регулярная задача" : "Задача"} ${truncateStart(data.id)} запущена`,
          });
        } else {
          toastHandler.error({
            name: "createExportTask",
            title: data.cronTask ? "Запуск регулярной задачи" : "Запуск задачи",
            content: `${data.cronTask ? "Регулярную задачу" : "Задачу"} ${truncateStart(data.id)} не удалось запустить`,
          });
        }
      });
  },
  {
    name: "startExportTaskRequest",
  },
).pipe(withAbort());
